import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginByEdsComponent } from './login-by-eds/login-by-eds.component';
import { LoginMenuComponent } from './login-menu/login-menu.component';
import { SimpleLoginComponent } from './simple-login/simple-login.component';
import { SharedModule } from '../../shared/shared.module';
import { LoginLayoutComponent } from './login-layout.component';
import { LoginSidebarComponent } from './login-sidebar/sidebar.component';
import { LayoutModule } from '../../core/layout/layout.module';
import { RegistrationModule } from './registration/registration.module';
import { RestorePasswordComponent } from './restore-password/restore-password.component';
import { LandingSharedModule } from './landing-shared/landing-shared.module';
import { LoginBySmsComponent } from './login-by-sms/login-by-sms.component';

@NgModule({
  imports: [
    AuthRoutingModule,
    LayoutModule,
    SharedModule,
    FormsModule,
    RegistrationModule,
    LandingSharedModule,
    ReactiveFormsModule,
  ],
  exports: [
  ],
  declarations: [
    LoginLayoutComponent,
    LoginSidebarComponent,
    LoginByEdsComponent,
    LoginBySmsComponent,
    LoginMenuComponent,
    SimpleLoginComponent,
    RestorePasswordComponent,
  ],
  providers: [],
})
export class AuthModule {
}
